/**
 * @description 更新類型 (enum)
 */
export enum MethodTypesEnum {
  /** 更新會員資料 */
  MPI = 'MPI',
  /** 更新會員密碼 */
  MPP = 'MPP',
  /** 啟用網投權限 */
  AOI = 'AOI'
}
